import React, { useEffect, useRef, useState } from "react";
import { useTheme } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { getJCJPIDs } from "../../../../utils/common/index";
import { normalizeRechargeSalesData } from "../../../../utils/rechargeSalesDataShape";
import { triggerFetchRechargeSalesAPI } from "../../../../redux/actions/rechargeSalesAction";
import PrimarySalesView from "../../../../views/rechargeSales/sales/component/primarySalesView";

const PrimarySales = (props) => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const { url } = props;
  const filterData = props.filterValue;
  const { headerUnit } = useSelector((state) => state.homeReducer);
  const { rechargeSalesObj, rechargeSalesCsvLoading } = useSelector(
    (state) => state.rechargeSalesReducer,
  );
  const [mainValue, setMainValue] = useState(0);
  const PreviousValue = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  };

  let { level, jioPointId, partnerRT, id, retailerId } = getJCJPIDs(filterData);

  const body = {
    id: id,
    partnerRoleType: partnerRT,
    fromDate: props.startDate,
    toDate: props.endDate,
    section: props.section,
    dispValue: headerUnit.unit,
    moduleName: props.moduleName,
    jprTypeName:
      filterData.selectedCategory && filterData.selectedCategory !== "ALL"
        ? filterData.selectedCategory
        : "",
    level,
    jioPointId,
    retailerId,
    dist: "",
  };
  const pV = PreviousValue(filterData);
  const pv2 = PreviousValue(headerUnit);

  useEffect(() => {
    function fetchData() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: props.url,
        },
        params: body,
        extraData: props.url,
      };

      return dispatch(triggerFetchRechargeSalesAPI(obj));
    }
    if (rechargeSalesObj && rechargeSalesObj.salesData[url] === undefined) {
      fetchData();
    }
    // if (
    //   pv2 &&
    //   pv2.headerUnit !== headerUnit
    // ) {
    //   fetchData();
    // }
    if (
      pV &&
      pV.selectedCategory !== filterData &&
      filterData.selectedCategory
    ) {
      fetchData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.data,
    props.startDate,
    props.endDate,
    headerUnit,
    filterData.selectedCategory,
  ]);

  const mainHandleChange = (event, newMainValue) => {
    setMainValue(newMainValue);
  };

  const endpointData = rechargeSalesObj && rechargeSalesObj.salesData;
  const raw = endpointData && endpointData[url] && endpointData[url][0];
  const data = raw ? normalizeRechargeSalesData(raw) : undefined;

  return (
    <>
      <PrimarySalesView
        rechargeSalesObj={rechargeSalesObj}
        triggerFetchRechargeSalesAPI={triggerFetchRechargeSalesAPI}
        mainHandleChange={mainHandleChange}
        setMainValue={setMainValue}
        mainValue={mainValue}
        data={data}
        theme={theme}
        body={body}
        headerUnit={headerUnit}
        rechargeSalesCsvLoading={rechargeSalesCsvLoading}
        filterValue={props.filterValue}
        filterData={filterData}
        id={id}
        csvUrl={props.csvUrl}
        isCsvActive={props.isCsvActive}
        tileName={props.tileName}
        moduleName={props.moduleName}
        section={props.section}
        startDate={props.startDate}
        endDate={props.endDate}
      />
    </>
  );
};

export default PrimarySales;
